<template>
  <section class="login-content bg-login-img posicionLogin" @mousemove="handleMouseMove" @mouseleave="resetTransform">
    <!-- <img src="../../../assets/images/login/02.png" class="lb-img" alt="">
         <img src="../../../assets/images/login/03.png" class="rb-img" alt=""> -->

    <div class="container h-100">
      <b-row class="align-items-center justify-content-center h-100">
        <div class="col-12">
          <b-row class="align-items-center">
            <div class="col-lg-6 mb-lg-0 mb-4 mt-lg-0 mt-4 responsive-xl-md content-logo principal">
              <img src="/img/HXWhite.png" class="img-fluid w-80 display-dark logo" alt="HXLogo-icon" :style="logoStyle" />
              <img src="/img/HXWblack.png" class="img-fluid w-80 display-light logo" alt="HXLogo-icon" :style="logoStyle" />
              <!-- <img src="../../../assets/images/login/01.png" class="img-fluid w-80" alt="" /> -->
            </div>
            <b-col lg="6 " class="card p-5 principal" style="border-radius: 5px">
              <span class="line"></span>
              <span class="line"></span>
              <span class="line"></span>
              <span class="line"></span>
              <!-- <img src="/img/HXLogoWhite.png" class="img-fluid rounded-normal " alt="logo" style="width: 100%; " /> -->
              <!-- <img src="/img/HXLogoBlack.png" class="img-fluid rounded-normal display-light" alt="logo" style="width: 90%" /> -->
              <img class="mb-sm-2 mb-0 p-md-5 display-dark" src="/img/HXLogoWhite.png" alt="HXLogo" />
              <img class="mb-sm-2 mb-0 p-md-5 display-light" src="/img/HXLogoBlack.png" alt="HXLogo" />

              <!-- <p>To Keep connected with us please login with your personal info.</p> -->
              <!-- <form @submit.prevent="login"> -->
              <form @submit.prevent="loginGetEmpresaPersona()" class="mb-5" v-if="paso2 == false && paso3 == false">
                <b-row>
                  <b-col lg="12">
                    <label class="ml-1">Email</label>
                    <div class="floating-label form-group">
                      <input required @focus="changeColorFocus" @blur="handleUnFocus" class="form-control" id="email" type="email" placeholder=" " v-model="Usuario" />
                    </div>
                    <!-- <div class="form-group mt-3">
                      <div class="d-flex align-items-center px-2 py-1 rounded">
                        <input type="checkbox" v-model="tipoLogin" class="mr-2" />
                        <span>Inicio desde aplicación</span>
                      </div>
                    </div> -->
                    <button type="submit" class="btn-block btn-secondary py-2">Ingresar</button>
                  </b-col>
                </b-row>
              </form>

              <form @submit.prevent="loginGetPersona()" v-if="paso2 == true" class="mb-5">
                <b-row>
                  <b-col lg="12" v-if="paso2 == true">
                    <!-- Mostrar solo el mensaje de "Ingresando..." cuando isAuthOk es true -->
                    <div v-if="isAuthOk" class="text-center">
                      <p class="h3">Ingresando...</p>
                    </div>

                    <!-- Mostrar el formulario solo cuando isAuthOk es false -->
                    <div v-else>
                      <OTPInput v-if="tipoAuth == 1" ref="otpRef" :length="claveLength" @complete="onOtpComplete" @resend="reenviarCodigo" />

                      <div v-if="tipoAuth == 2">
                        <label class="ml-1">Ingrese su contraseña:</label>
                        <div class="floating-label form-group position-relative">
                          <input
                            v-on:keyup.enter="onEnter()"
                            @input="credentialInvalid = false"
                            @focus="changeColorFocus"
                            @blur="handleUnFocus"
                            required
                            class="form-control pr-5"
                            :type="showPassword ? 'text' : 'password'"
                            placeholder=""
                            v-model="Contrasena"
                          />
                          <button type="button" class="btn-toggle-password" @click="showPassword = !showPassword" tabindex="-1">
                            <i :class="showPassword ? 'ri-eye-off-line' : 'ri-eye-line'"></i>
                          </button>
                          <span v-if="credentialInvalid" class="invalid-password">Credenciales incorrectas</span>
                        </div>
                        <button type="submit" class="btn-block btn-secondary py-2 mt-3">Continuar</button>
                      </div>
                    </div>

                    <!-- 
                    <div v-if="terminosYCondiciones.hasOwnProperty('texto')" class="center mb-3" style="display: flex">
                      <vs-checkbox required v-model="aceptoTerminos"> </vs-checkbox>
                      <span class="ml-3 pointer" @click="checkAceptoTerminos()">Términos y condiciones y aviso de privacidad</span>
                    </div>
                    <button type="submit" class="btn-block btn-secondary py-2">Ingresar</button> -->
                  </b-col>

                  <!-- <b-col lg="6" >
                                 <div class="custom-control custom-checkbox mb-3">
                                    <input type="checkbox" class="custom-control-input" id="customCheck1">
                                    <label class="custom-control-label text-light mp-1" for="customCheck1">Recordar</label>
                                 </div>
                              </b-col> -->
                  <!-- <b-col lg="6" >
                                 <router-link to="/auth/recover-password" class="text-light float-right">¿Olvidó su contraseña?</router-link>
                              </b-col> -->
                </b-row>
              </form>
              <form v-if="paso3 == true">
                <b-row>
                  <b-col lg="12">
                    <validarSesion @renviarCodigo="loginGetEmpresaPersona()" @cerrarConexion="cerrarConexion()" :codigo="idSolicitud" />
                  </b-col>
                </b-row>
              </form>
              <span class="mb-2">{{ mensaje }}</span>

              <div class="row">
                <div class="col-12 text-center mt-5">
                  <span class="text-light pt-5">20260311</span><br />
                  <span class="text-light pt-5">Helexium ® 2026</span>
                </div>
              </div>
              <!-- </form> -->
            </b-col>
          </b-row>
        </div>
      </b-row>
    </div>

    <b-modal id="tyc-modal" title="Términos y Condiciones" size="xl" hide-footer>
      <div class="row px-5">
        <div class="col-md-12 content ql-editor" v-html="terminosYCondiciones.texto"></div>
      </div>
    </b-modal>
    <ParticlesLogin />
  </section>
</template>
<script>
// import Swal from "sweetalert2";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import ParticlesLogin from "@/components/particles/particles";

import { mapActions, mapMutations, mapState } from "vuex";
import OTPInput from "../../../components/helexium/OTPInput.vue";
import validarSesion from "../../../components/helexium/validarSesion.vue";

import * as signalR from "@microsoft/signalr";
import Swal from "sweetalert2";

export default {
  name: "SignIn",
  components: {
    ParticlesLogin,
    OTPInput,
    validarSesion,
  },

  data() {
    return {
      claveLength: 0,
      isAuthOk: false,
      credentialInvalid: false,
      xAxis: 0,
      yAxis: 0,
      Usuario: "", // "admindemo@testing.com", // "RRHH4@testing.com", //
      Contrasena: "",
      mensaje: "",
      paso2: false,
      paso3: false,
      PersonaAct: {},
      terminosYCondiciones: {},
      aceptoTerminos: false,
      colorBorder: "rgb(242, 19, 67)",
      tipoLogin: false,
      signalRConnection: null,
      idSolicitud: null,
      tipoAuth: null,
      showPassword: false,
    };
  },
  mounted() {
    localStorage.removeItem("setPersonaAct");
    localStorage.removeItem("tk");
    // limpiar datos de autenticacion de sisi
    localStorage.removeItem("sisiAuth");

    const isDarkModeActive = JSON.parse(localStorage.getItem("isdark")) == null ? false : JSON.parse(localStorage.getItem("isdark"));
    const body = document.querySelector("body");

    if (isDarkModeActive) {
      // document.body.classList.add("dark");
      body.classList.add("dark");
    } else {
      // alert(isDarkModeActive)
      body.classList.remove("dark");
    }
  },
  computed: {
    ...mapState("pesv", ["credential"]),
    logoStyle() {
      return {
        transform: `rotateY(${this.xAxis}deg) rotateX(${this.yAxis}deg)`,
      };
    },
  },
  methods: {
    ...mapMutations("pesv", ["setSisiAuth"]),
    ...mapActions("pesv", ["useRequestSisi"]),
    onOtpComplete(code) {
      this.Contrasena = code;
      this.loginGetPersona();
    },
    reenviarCodigo() {
      console.log("Reenviando OTP...");
      this.loginGetEmpresaPersona();
    },
    handleMouseMove(event) {
      const xAxis = (window.innerWidth / 2 - event.pageX) / 50;
      const yAxis = (window.innerHeight / 2 - event.pageY) / 25;
      this.xAxis = xAxis;
      this.yAxis = yAxis;
    },
    resetTransform() {
      this.xAxis = 0;
      this.yAxis = 0;
    },
    async authSisi() {
      // Autenticar con Sisi
      const authResponse = await this.useRequestSisi({
        method: "POST",
        path: "autenticacion/inicio-sesion",
        body: this.credential,
      });

      if (!authResponse.ok) {
        return;
      }

      // Guardar credenciales en el store y en localStorage
      this.setSisiAuth(authResponse.data);
    },
    checkAceptoTerminos() {
      this.$bvModal.show("tyc-modal");
    },
    async getTerminosYCondiciones(id) {
      try {
        let res = await this.$store.dispatch("hl_get", {
          path: "TerminosYCondiciones/GetTerminosYCondicionesPersonaPaisId/" + id,
        });
        this.terminosYCondiciones = res;
      } catch (error) {
        this.terminosYCondiciones = {};
      }
    },
    async onEnter() {
      await this.loginGetPersona();
    },
    async loginGetPersona() {
      let data = { Usuario: this.Usuario, Contrasena: this.Contrasena };
      try {
        this.credentialInvalid = false;
        this.isAuthOk = false;
        this.$isLoading(true);
        let res = await this.$store.dispatch("hl_post", {
          path: "Authentication/LoginPersona",
          data: data,
        });

        console.log("res", res);

        this.isAuthOk = res.id ? true : false;

        if (res.id) {
          localStorage.setItem(
            "credenciales",
            JSON.stringify({
              personaId: res.id,
              dynamicPassword: this.Contrasena,
            })
          );

          this.PersonaAct = res;
          let tokenres = await this.$store.dispatch("posthlw", {
            path: "Authentication/GetToken",
            data: data,
          });
          this.$isLoading(false);

          //tokenres = await tokenres.json();
          this.$store.commit("setToken", tokenres.token);
          this.$store.commit("setPersonaAct", res);
          localStorage.setItem("tk", tokenres.token);
          localStorage.setItem("user", JSON.stringify(res.data));
          this.$store.dispatch("wrapperSetUserLoggedIn", res);

          //aceptando terminos y condiciones
          let dataTerminos = {
            PersonaId: res.id,
            fecha: this.$moment.tz(new Date(), "America/Bogota").format("YYYY-MM-DDTHH:mm"),
          };
          await this.fetchJsonData();
          await this.$store.dispatch("hl_post", {
            path: "TerminosYCondiciones/AceptaTerminosYCondiciones/",
            data: dataTerminos,
          });
          this.$router.push("dashboard");
          this.mensaje = "";
          //return true;
        } else {
          this.$isLoading(false);
          if (this.tipoAuth == 2) {
            // Swal.fire("Credenciales incorrectas!", "", "warning");
            this.Contrasena = "";
            this.credentialInvalid = true;
          } else if (this.tipoAuth == 1) {
            // this.PersonaAct = {};
            this.$refs.otpRef?.setErrorState();
          }
          //this.mensaje = "Credenciales incorrectas.";
          //return false;
        }

        // autenticar con sisi
        await this.authSisi();
      } catch (error) {
        console.log("error", error);
        this.$isLoading(false);
        this.PersonaAct = {};
        //return false;
      }
    },

    async fetchJsonData() {
      let dataGroupV2 = {};
      try {
        let res = await this.$store.dispatch("hl_get", {
          path: `RegistrosJsonControlAccesos/GetLatestJsonFilter/${this.Usuario}`,
        });
        //console.log("La respuesta del groupV2 es: ", res);

        if (res && res.registroJson) {
          try {
            let cleanedJsonString = res.registroJson.replace(/\\"/g, '"').replace(/\\u([0-9a-fA-F]{4})/g, "\\u$1");
            const parsedJson = JSON.parse(cleanedJsonString);

            dataGroupV2 = {
              id: res.id,
              fechaRegistro: res.fechaRegistro,
              registroJson: parsedJson,
            };
            //console.log("La respuesta del groupV2 es: ", dataGroupV2);
            localStorage.setItem("dataGroupV2", JSON.stringify(dataGroupV2.registroJson));
            //localStorage.setItem("dataGroupV2", dataGroupV2.registroJson.data);
          } catch (parseError) {
            dataGroupV2 = null;
          }
        } else {
          dataGroupV2 = null;
        }
      } catch (error) {
        dataGroupV2 = null;
      }
    },

    async loginGetEmpresaPersona() {
      this.$isLoading(true);

      try {
        let res = null;

        if (!this.tipoLogin) {
          // GET
          res = await this.$store.dispatch("gethlw", {
            path: `Persona/GetEmpresaPersona/${this.Usuario}`,
          });
        } else {
          // POST
          res = await this.$store.dispatch("posthlw", {
            path: "Persona/EnviarSolicitudLoginApp",
            data: this.Usuario,
          });
        }

        console.log("[loginGetEmpresaPersona]", res);

        if (res.success && res.data) {
          this.mensaje = "";

          if (!this.tipoLogin) {
            this.claveLength = res.data.claveLength;
            this.paso2 = true;
            this.tipoAuth = res.data.data.tipoAuth;
          } else {
            this.paso3 = true;
            this.idSolicitud = res.data;

            await this.conectarSignalR(this.idSolicitud);
          }

          //await this.getTerminosYCondiciones(this.Usuario);
        } else {
          if (res.message == "¡Error al enviar la solicitud inicio sesión!") {
            Swal.fire({
              title: res.message,
              text: res.errorDetail,
              icon: "error",
              confirmButtonText: "Aceptar",
            });
          } else {
            this.mensaje = res.errorDetail || "Ocurrió un error inesperado.";
          }
        }
      } catch (error) {
        console.error("[loginGetEmpresaPersona:catch]", error);
        this.mensaje = "No se pudo completar la solicitud. Intenta de nuevo.";
      } finally {
        this.$isLoading(false);
      }
    },

    async login() {
      this.$isLoading(true);
      let data = JSON.stringify({
        Usuario: this.Usuario,
        contrasena: this.Contrasena,
      });
      try {
        let res = await this.$store.dispatch("hl_login", { data: data });
        this.$isLoading(false);
        console.log("rs", res);
        if (res.id) {
          this.PersonaAct = res;
          this.$router.push("dashboard");
          //return true;
        } else {
          this.PersonaAct = {};
          this.mensaje = "Credenciales incorrectas.";
          //return false;
        }
      } catch (error) {
        this.$isLoading(false);
        this.PersonaAct = {};
        //return false;
      }
    },
    changeColorFocus() {
      this.colorBorder = "#4677d5";
    },
    handleUnFocus() {
      this.colorBorder = "rgb(242, 19, 67)";
    },

    async conectarSignalR(requestId) {
      try {
        this.signalRConnection = new signalR.HubConnectionBuilder()
          .withUrl(`${this.$store.state.hl_url}hubs/login`) // esta url va a consultar el socket de signalR
          .configureLogging(signalR.LogLevel.Information)
          .build();

        // Escuchar evento desde el servidor
        this.signalRConnection.on("loginAutorizado", async (data) => {
          console.log("✅ Login autorizado:", data);

          this.$store.commit("setToken", data.loginExitoso.token);
          this.$store.commit("setPersonaAct", data.loginExitoso.persona);
          localStorage.setItem("tk", data.loginExitoso.token);
          localStorage.setItem("user", JSON.stringify(data.loginExitoso.persona));

          this.$store.dispatch("wrapperSetUserLoggedIn", data.loginExitoso.persona);

          //aceptando terminos y condiciones
          let dataTerminos = {
            PersonaId: data.loginExitoso.persona.id,
            fecha: this.$moment.tz(new Date(), "America/Bogota").format("YYYY-MM-DDTHH:mm"),
          };
          await this.fetchJsonData();
          await this.$store.dispatch("hl_post", {
            path: "TerminosYCondiciones/AceptaTerminosYCondiciones/",
            data: dataTerminos,
          });
          await this.$router.push("dashboard");
          this.signalRConnection.stop();
        });

        await this.signalRConnection.start();
        console.log("🟢 Conectado a SignalR");

        // Suscribirse a un grupo
        await this.signalRConnection.invoke("SuscribirseASolicitud", requestId.toUpperCase(), this.Usuario);
        console.log(`📡 Suscrito al grupo: ${requestId.toUpperCase()}`);

        this.signalRConnection.onclose((error) => {
          console.log("🔴 Conexión SignalR cerrada");
          if (error) {
            console.error("❌ Error en desconexión:", error);
            console.log(`Se perdió la conexión con el servidor`);
          } else {
            console.log(" Desconexión normal (posible timeout de 1 minuto)");
            console.log(`📡 La sesión ha expirado por inactividad`);
          }
        });

        this.signalRConnection.on("solicitudVencida", (data) => {
          console.log("¡Tiempo agotado! La solicitud ha expirado", data);
          this.signalRConnection.stop();
          window.location.reload();
        });

        this.signalRConnection.on("forzarDesconexion", async (data) => {
          console.log("¡Forzar desconexión! ya existe otra solicitud activa", data.mensaje);
          const result = await Swal.fire({
            title: "Petición ya solicitada, por favor espere 1 minuto.",
            text: data.mensaje,
            icon: "warning",
            confirmButtonText: "Aceptar",
            allowOutsideClick: false, // no dejar cerrar fuera
          });

          if (result.isConfirmed) {
            this.signalRConnection.stop();
            window.location.reload();
          }
        });
      } catch (error) {
        console.error("❌ Error al conectar con SignalR", error);
      }
    },

    async cerrarConexion() {
      console.log("¡Expirado!");
      this.signalRConnection.stop();
    },
  },
};
</script>

<style scoped>
:root {
  --color1-dark: #1e2023;
  --color1-light: #ffffff;
  --color2: rgb(242, 19, 67);
  --color3: #4677d5;
}

.invalid-password {
  color: #dc3545;
  font-size: 0.9rem;
  margin-top: 0.5rem;
}

.btn-toggle-password {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 5px 10px;
  color: #6c757d;
  transition: color 0.3s;
  z-index: 10;
}

.btn-toggle-password:hover {
  color: #4677d5;
}

.btn-toggle-password i {
  font-size: 1.2rem;
}

.content-logo {
  animation: bounce 2s infinite ease-in-out;

  &::after {
    content: "";
    position: absolute;
    bottom: -10px;
    left: 20%;
    width: 40%;
    height: 20px;
    background: rgba(0, 0, 0, 0.2);
    filter: blur(2px);
    border-radius: 50%;
    transition: transform 0.2s ease-out, opacity 0.2s ease-out;
    animation: shadowBounce 2s infinite ease-in-out;
  }

  .dark &::after {
    background: rgba(0, 0, 0, 0.5);
  }

  & .logo {
    filter: drop-shadow(2.5px 2.5px 5px rgba(0, 0, 0, 0.2));
    transition: transform 0.2s ease-out;
    transform-style: preserve-3d;
  }
}

.card {
  /* box-shadow: 0 20px 50px rgba(0, 0, 0, 0.2); */
  overflow: hidden;
}

.card .line:nth-child(1) {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background: v-bind("`linear-gradient(to right, var(--color1-light), ${colorBorder})`");

  .dark & {
    background: v-bind("`linear-gradient(to right, var(--color1-dark), ${colorBorder})`");
  }

  animation: animate1 2s linear infinite;
}

@keyframes animate1 {
  0% {
    transform: translateX(-100%);
  }

  100% {
    transform: translateX(100%);
  }
}

.card .line:nth-child(2) {
  position: absolute;
  top: 0;
  right: 0;
  width: 2px;
  height: 100%;
  background: v-bind("`linear-gradient(to bottom, var(--color1-light), ${colorBorder})`");

  .dark & {
    background: v-bind("`linear-gradient(to bottom, var(--color1-dark), ${colorBorder})`");
  }

  animation: animate2 2s linear infinite;
  animation-delay: 1s;
}

@keyframes animate2 {
  0% {
    transform: translateY(-100%);
  }

  100% {
    transform: translateY(100%);
  }
}

.card .line:nth-child(3) {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background: v-bind("`linear-gradient(to left, var(--color1-light), ${colorBorder})`");

  .dark & {
    background: v-bind("`linear-gradient(to left, var(--color1-dark), ${colorBorder})`");
  }

  animation: animate3 2s linear infinite;
}

@keyframes animate3 {
  0% {
    transform: translateX(100%);
  }

  100% {
    transform: translateX(-100%);
  }
}

.card .line:nth-child(4) {
  position: absolute;
  top: 0;
  left: 0;
  width: 2px;
  height: 100%;
  background: v-bind("`linear-gradient(to top, var(--color1-light), ${colorBorder})`");

  .dark & {
    background: v-bind("`linear-gradient(to top, var(--color1-dark), ${colorBorder})`");
  }

  animation: animate4 2s linear infinite;
  animation-delay: 1s;
}

@keyframes animate4 {
  0% {
    transform: translateY(100%);
  }

  100% {
    transform: translateY(-100%);
  }
}

@keyframes bounce {
  0%,
  100% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(-10px);
  }
}

@keyframes shadowBounce {
  0%,
  100% {
    transform: scale(1);
    opacity: 0.2;
  }

  50% {
    transform: scale(0.8);
    opacity: 0.4;
  }
}

.principal {
  z-index: 100;
  position: relative;
}
</style>
